import { TRACKING_EVENTS } from '@common/constants'
import { usePageLoadV2 } from '@common/hooks'
import { BUY_TRACKING_COMPONENTS } from '@buy/constants'
import { useBuyTracking } from './useBuyTracking'

export interface CustomizePageTrackingParams {
    dependencies: Array<string>
}

export const useCustomizePageTracking = (params: CustomizePageTrackingParams) => {
    const componentName = BUY_TRACKING_COMPONENTS.CUSTOMIZE_PAGE
    const { track } = useBuyTracking()
    const trackCustomizeViewClick = () => {
        track({ event: TRACKING_EVENTS.VIEW_ITEM }, componentName)
    }
    usePageLoadV2(() => {
        track({ event: TRACKING_EVENTS.BEGIN_CHECKOUT, eventData: { step: 1 } }, componentName)
    }, params.dependencies)
    return { trackCustomizeViewClick }
}
